<template>
  <section class="hero">
    <div class="hero-container">
      <div class="hero-content">
        <h1 class="hero-title">
          <transition name="fade" mode="out-in">
            <span :key="currentPhraseIndex" v-html="currentPhrase"></span>
          </transition>
        </h1>
        <div class="sections">
          <div class="publications-section">
            <p class="publications-text"> {{ $t('heroHighlightTexe2') }} </p>
            <router-link :to="{ name: $t('publicationsRouterName') }" tag="a" class="publications-button">{{
              $t('heroHighlightButtonText') }}</router-link>
          </div>
          <div class="publications-section">
            <p class="publications-text"> {{ $t('prepareControlFR22') }} </p>
            <router-link :to="{ name: $t('financial-reports-templates') }" tag="a" class="prepare-button">{{
              $t('prepareControlFR22') }}</router-link>
          </div>
        </div>

      </div>
      <div class="hero-image">
        <img src="../../assets/Hero_Image.png" alt="Hero illustration" loading="lazy">
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  data() {
    return {
      phrases: [
        this.$t('heroPhrase1'),
        this.$t('heroPhrase2'),
        this.$t('heroPhrase3')
      ],
      currentPhraseIndex: 0,
      intervalId: null,
    }
  },
  computed: {
    ...mapGetters(["getSelectedLanguage"]),
    currentPhrase() {
      return this.phrases[this.currentPhraseIndex]
    }
  },
  mounted() {
    this.startCarousel()
  },
  beforeDestroy() {
    this.stopCarousel()
  },
  methods: {
    startCarousel() {
      this.intervalId = setInterval(() => {
        this.currentPhraseIndex = (this.currentPhraseIndex + 1) % this.phrases.length
      }, 4000)
    },
    stopCarousel() {
      if (this.intervalId) {
        clearInterval(this.intervalId)
      }
    },
    loadPhrases() {
      this.phrases = [
        this.$t('heroPhrase1'),
        this.$t('heroPhrase2'),
        this.$t('heroPhrase3')
      ];
    }
  },
  watch: {
    getSelectedLanguage() {
      this.loadPhrases();
    }
  },
}
</script>

<style>
.hero {
  background: radial-gradient(circle at center,
      #BDCDFB 0%,
      var(--secondary-color) 100%);
  padding: 2% 7%;
  /* min-height: 500px; */
  display: flex;
  align-items: center;
  width: 100%;
}

.hero-container {
  width: 100%;
  display: flex;
  gap: 10px;
  /* align-items: center; */
  align-items: stretch;
}

.hero-content,
.hero-image {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.hero-content {
  width: 65%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  margin-top: auto;
}

.hero-title {
  font-size: 50px;
  line-height: 70px;
  font-weight: 700;
  margin-bottom: 2.5rem;
  /* color: #1a1a1a; */
  color: #111;
  /* letter-spacing: -0.02em; */
  width: 90%;
  flex-grow: 1;
  display: flex;
  align-items: center;
}

.highlight {
  color: var(--main-color);
  position: relative;
  display: inline-block;
}

.highlight::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: var(--main-color);
  transform: scaleX(0);
  transform-origin: right;
  transition: transform 0.3s ease;
}

.hero-content:hover .highlight::after {
  transform: scaleX(1);
  transform-origin: left;
}

.sections {
  display: flex;
  gap: 25px;
  width: 95%;
}

.publications-section {
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(8px);
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  width: 50%;
  /* margin-top: auto; */
  max-height: 200px;
  min-height: 170px !important;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.publications-text {
  font-size: 24px;
  line-height: 1.2;
  font-weight: 500;
  color: #465481;
  /* margin-bottom: 2rem; */
  margin-bottom: auto;
}

.prepare-button {
  display: inline-block;
  background-color: var(--main-color);
  /* background-color: transparent; */
  /* color: var(--main-color); */
  color: white;
  padding: 0.75rem;
  border-radius: 0.5rem;
  /* border: 2px solid var(--main-color); */
  /* font-size: 1.125rem; */
  font-size: 20px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  text-align: center;
  /* width: 100%; */
  box-shadow: 0 2px 4px rgba(176, 198, 249, 0.2);
  margin-top: 10px;
}

.prepare-button:hover {
  color: white;
  /* background-color: var(--main-color); */
  text-decoration: none;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(176, 198, 249, 0.3);
}

.publications-button {
  display: inline-block;
  background-color: #F68600;
  color: white;
  padding: 0.75rem;
  border-radius: 0.5rem;
  /* font-size: 1.125rem; */
  font-size: 20px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  text-align: center;
  /* width: 40%; */
  box-shadow: 0 2px 4px rgba(246, 134, 0, 0.2);
  margin-top: 10px;
}

.publications-button:hover {
  background-color: #f69927;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(246, 134, 0, 0.3);
  text-decoration: none;
  color: var(--secondary-color);
  text-decoration: underline;
}

.hero-image {
  width: 35%;
  position: relative;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  display: flex;
  max-height: 320px;
}

.hero-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transition: transform 0.6s ease;
}

.hero-image:hover img {
  transform: scale(1.05);
}

.slide-fade-enter-active {
  transition: all 0.8s ease;
  position: relative;
}

.slide-fade-leave-active {
  transition: all 0.8s ease;
  position: relative;
}

.slide-fade-enter-from {
  transform: translateY(20px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.phrase {
  display: block;
  position: relative;
  animation: textReveal 0.8s ease forwards;
}

@keyframes textReveal {
  0% {
    transform: scale(0.95);
    opacity: 0;
  }

  50% {
    transform: scale(1.02);
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}


@media (max-width: 1200px) {
  .hero-title {
    font-size: 38px;
    line-height: 45px;
    margin-bottom: 20px;
  }

  .publications-text {
    /* font-size: 1.125rem; */
    font-size: 18px;

  }

  .publications-button {
    /* width: 50%; */
  }
}

@media (max-width: 992px) {
  .sections {
    width: 100%;
  }

  .hero-container {
    flex-direction: column;
    gap: 2rem;
  }

  .hero-content,
  .hero-image {
    width: 100%;
  }

  .hero-content,
  .hero-image {
    width: 100%;
    /* Remove the fixed height for the image */
  }

  .hero-title,
  .publications-section {
    width: 100%;
  }

  .publications-button {
    /* width: 40%; */
  }

  .hero-image {
    height: 400px;
  }
}

@media (max-width: 768px) {
  .sections {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .hero {
    padding: 4rem 7%;
  }

  .hero-title {
    /* font-size: 1.75rem; */
  }

  .publications-section {
    padding: 1.5rem;
    max-height: unset;
    min-height: unset !important;
  }

  .publications-text {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .publications-button {
    /* width: 50%; */
  }

  .hero-image {
    height: 300px;
  }
}

@media (max-width: 480px) {
  .hero {
    padding: 3rem 7%;
  }

  .hero-title {
    /* font-size: 1.5rem; */
    font-size: 30px;
    line-height: 35px;
  }

  .hero-image {
    height: 250px;
  }

  .publications-button {
    width: 100%;
  }
}
</style>